module.exports = __webpack_public_path__ + "img/blog-3-2.c368f404.webp";